import { memo, type ReactNode } from 'react';
import { SectionContainer } from './SectionContainer';
import { IconButton } from '~/components/ui/IconButton';
import { classNames } from '~/utils/classNames';

interface ContainerWithBackButtonProps {
  children: ReactNode;
  onClose: VoidFunction;
  title: string;
  className?: string;
}

export const ContainerWithBackButton = memo(({ onClose, children, className, title }: ContainerWithBackButtonProps) => (
  <SectionContainer
    className={classNames('gap-8', className)}
    title={
      <h2 className="flex items-center gap-2 font-semibold text-lg">
        <IconButton icon="i-heroicons:arrow-left-solid" size="sm" variant="ghost" onClick={onClose} />
        {title}
      </h2>
    }
  >
    {children}
  </SectionContainer>
));
